import React, { useState, useEffect, useRef, useContext } from "react";
import { Spin, Row, Col, TablePaginationConfig, notification } from "antdv5";
import { useParams, useHistory } from "react-router-dom";
import Container from "components/common/Container";
import DefaultLayout from "components/layout/DefaultLayout";
import useAPI from "components/customHook/useApi";
import { RaceOutter, GradeDetail } from "../styles/Racelive";
import RaceliveTabs from "components/pages/Racelive/Tabs";
import RaceliveTable from "components/pages/Racelive/RaceliveTable";
import {
  flyReference,
  refreshSpanSpeed,
} from "components/pages/Racelive/RaceliveCalculations";
import TableSkeleon from "components/pages/Racelive/TableSkeleton";
import RaceLiveData from "components/pages/Racelive/RaceLiveData";
import type {
  IGameDetail,
  IGameDetailExportData,
  IGameTop,
  IMatchGame,
} from "../api_types";
import type { Obj, ITableData } from "../client_types";
import { context } from "components/context/Context";
import useEffectOnce from "components/customHook/useEffectOnce";
import { GETJsonGameID, GETJsonRaceLiveSetting } from "../api";
import XLSX from "xlsx";

export interface IPartialGameTop {
  ClockStop: string;
  ClockStart: string;
  BasicMetresPerMin: string;
  TotalBird: string;
  NowCount: string;
  StringE_HMS: string;
  StringN_HMS: string;
}
const initialState = {
  data: [],
  totalPage: 0,
  count: "",
};
const Racelive = ({ showNewest }: { showNewest: boolean }) => {
  const {
    handleAuth,
    preventRefreshCount,
    setLoading: setSpinLoading,
    loading: spinLoading,
    handleEnter,
  } = useAPI();
  const { state, dispatch } = useContext(context);
  let history = useHistory();
  const [api, ctx] = notification.useNotification();
  const [type, setType] = useState<string>("");
  const [data, setData] = useState<IGameTop[] | IPartialGameTop[] | null>(null);
  const [grade, setGrade] = useState<ITableData<IGameDetail>>(initialState);
  const [gather, setGather] = useState<ITableData<IGameDetail>>(initialState);
  const [speed, setSpeed] = useState<string | null>(null);
  const [fly, setFly] = useState<string | null>(null);
  const [rank, setRank] = useState("");
  const [sortText, setSortText] = useState("排序");
  const [matchList, setMatchList] = useState<IMatchGame[] | null>(null);
  let { matchid, gameid, gametype } = useParams() as {
    matchid: string;
    gameid: string;
    gametype: string;
  };
  const [gameTypeSwitch, setGameTypeSwitch] = useState(state.gameType || "0");

  const [findName, setFindName] = useState({
    matchGameID: gameid,
    searchFeetNo: "",
    searchName: "",
  });
  const [pageInfo, setPageInfo] = useState({
    pageSize: 100,
    current: 1,
  });
  const [gameName, setGameName] = useState(
    localStorage.getItem("gameName") ? localStorage.getItem("gameName") : null
  );
  const [countDown, setCountDown] = useState(60);
  const [loading, setLoading] = useState(true);
  const [scoreCalcType, setScoreCalcType] = useState();
  const [settings, setSettings] = useState([]);
  const gameTypeString = gameTypeSwitch.toString();
  const isMatch = gameTypeString === "1" || gameTypeString === "2";

  /* settings */
  const settingsObj = Object.fromEntries(
    settings.map(({ settingName, settingValue1 }) => [settingName, settingValue1])
  );

  const handleMenuClick = (e: { key: string }) => {
    if (parseInt(e.key) === 1) {
      setRank("singleRankAsc");
      setSortText("单关排名(高到低)");
    } else if (parseInt(e.key) === 2) {
      setRank("singleRankDes");
      setSortText("单关排名(低到高)");
    } else if (parseInt(e.key) === 3) {
      setRank("totalRankAsc");
      setSortText("综合分速（高到低）");
    } else if (parseInt(e.key) === 4) {
      setRank("totalRankDes");
      setSortText("综合分速（低到高）");
    } else if (parseInt(e.key) === 5) {
      setRank("avgRankAsc");
      setSortText("平均分速（低到高）");
    } else if (parseInt(e.key) === 6) {
      setRank("avgRankDes");
      setSortText("平均分速（高到低）");
    }
  };
  const typeList = [
    {
      key: "2",
      label: "比赛",
    },
    {
      key: "0",
      label: "训练",
    },
  ];
  const matchDropdownList = matchList
    ? matchList.map((d) => ({
        key: JSON.stringify(d),
        label: d.MatchGameName,
      }))
    : [];

  const typeListOnClick = (e: { key: string }) => {
    setLoading(true);
    (async () => {
      const availableID = await GETJsonGameID(Number(matchid), Number(e.key));
      const firstGame = availableID?.[0]?.MatchGameID;
      console.log(availableID);
      if (firstGame) {
        history.push(`/racelive/${matchid}/${firstGame}/${e.key}`);
        setGameTypeSwitch(e.key);
        setType("grade");
        setPageInfo({ pageSize: 100, current: 1 });
        setFindName({
          ...findName,
          searchFeetNo: "",
          searchName: "",
        });
        preventRefreshCount(() => handleMatchGameID(e.key), 2);
        setData(null);
        setGrade(initialState);
        setGather(initialState);
      } else {
        api.info({
          message: "注意！",
          description: "没有赛事/训飞",
          placement: "top",
        });
        setLoading(false);
        return;
      }
    })();
  };
  const matchListDropdownOnClick = (e: { key: string }) => {
    setType("grade");
    setPageInfo({ pageSize: 100, current: 1 });
    setData(null);
    setGrade(initialState);
    setGather(initialState);
    const obj = JSON.parse(e.key);
    setScoreCalcType(obj.ScoreCalcType);
    setFindName({
      matchGameID: obj.MatchGameID,
      searchFeetNo: "",
      searchName: "",
    });
    dispatch({ gameid: obj.MatchGameID });
    setGameTypeSwitch(obj.MatchGameType);
    localStorage.setItem("gameName", obj.MatchGameName);
    history.push(
      `/racelive/${matchid}/${obj.MatchGameID}/${obj.MatchGameType}`
    );
    preventRefreshCount(() => fetchData(obj.MatchGameID), 2);
    preventRefreshCount(() => fetchGrade(obj.MatchGameID, 100, 1, "", ""), 2);
    setGameName(obj.MatchGameName);
  };
  const handleList = (key: string) => {
    setType(key);
    if (key === "grade") {
      fetchGrade(state?.gameid || undefined, 100, 1, "", "");
    } else {
      fetchGather(state?.gameid || undefined, 100, 1, "", "");
    }
    setPageInfo({ pageSize: 100, current: 1 });
    setFindName({ ...findName, searchFeetNo: "", searchName: "" });
  };
  const backPercent = (total: number, now: number) => {
    let result = (now / total) * 100;
    return result;
  };
  const fetchData = (matchGameID: string) => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_URL}ApiGetJsonGameDetailTop.ashx?MatchGameID=${matchGameID}&MatchID=${matchid}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.Data && res.Data.length !== 0) {
          setData(res.Data);
          localStorage.setItem("gameName", res.Data[0].MatchGameName);
          setGameName(res.Data[0].MatchGameName);
        } else {
          setData([]);
        }
      });
  };
  const fetchGrade = (
    matchGameID = "",
    pageSize = pageInfo.pageSize,
    current = pageInfo.current,
    searchName = findName.searchName,
    searchFeetNo = findName.searchFeetNo
  ) => {
    setLoading(true);
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }ApiGetJsonGameDetail.ashx?MatchGameId=${matchGameID}&MatchID=${matchid}&Sort=${rank}&SearchName=${encodeURIComponent(
        searchName
      )}&SearchFeetNo=${searchFeetNo}&PageSize=${pageSize}&NowPage=${current}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.Data?.length) {
          setGrade({
            data: res.Data,
            totalPage: res.Data[0].TotalCount,
            count: res.Data[0].Count,
          });
        } else {
          setGrade({
            data: [],
            totalPage: 0,
            count: "",
          });
        }
        setLoading(false);
      });
  };
  const fetchNewGrade = (pageSize: number, current: number) => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_URL}ApiGetJsonGameDetail.ashx?MatchGameId=${
        state?.gameid || ""
      }&MatchID=${matchid}&PageSize=${pageSize}&NowPage=${current}&Sort=${rank}&SearchName=${encodeURIComponent(
        findName.searchName
      )}&SearchFeetNo=${findName.searchFeetNo}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.Data !== null && res.Data.length !== 0) {
          setGrade({
            ...grade,
            totalPage: res.Data[0].TotalCount,
            count: res.Data[0].Count,
            data: res.Data,
          });
          setLoading(false);
        }
      });
  };
  const fetchGather = (
    matchGameID = findName.matchGameID,
    pageSize = pageInfo.pageSize,
    current = pageInfo.current,
    searchName = findName.searchName,
    searchFeetNo = findName.searchFeetNo
  ) => {
    setLoading(true);
    fetch(
      `${
        process.env.REACT_APP_API_URL
      }ApiGetJsonGatherBird.ashx?MatchGameID=${matchGameID}&MatchID=${matchid}&Sort=${rank}&SearchName=${encodeURIComponent(
        searchName
      )}&SearchFeetNo=${searchFeetNo}&PageSize=${pageSize}&NowPage=${current}`
    )
      .then((res) => res.json())
      .then((res) => {
        const numericCurrent =
          (typeof current === "string" ? parseInt(current) : current) || 1;
        const numericPageSize =
          (typeof pageSize === "string" ? parseInt(pageSize) : pageSize) || 100;

        if (res.Data !== null && res.Data.length !== 0) {
          let result = [...res.Data];
          for (let i = 0; i < res.Data.length; i++)
            result[i] = {
              ...res.Data[i],
              rank: (numericCurrent - 1) * numericPageSize + i + 1,
            };
          setGather({
            count: "0",
            totalPage: result[0].TotalCount,
            data: result,
          });
          setLoading(false);
        } else if (res.Data.length === 0) {
          setGather({
            data: [],
            totalPage: 0,
            count: "",
          });
          setLoading(false);
        }
      });
  };
  const fetchNewGather = (pageSize: number, current: number) => {
    setLoading(true);
    fetch(
      `${process.env.REACT_APP_API_URL}ApiGetJsonGatherBird.ashx?MatchGameId=${
        state?.gameid || ""
      }&MatchID=${matchid}&PageSize=${pageSize}&NowPage=${current}&Sort=${rank}&SearchName=${encodeURIComponent(
        findName.searchName
      )}&SearchFeetNo=${findName.searchFeetNo}`
    )
      .then((res) => res.json())
      .then((res) => {
        let result = [...res.Data];
        if (pageSize === 20) {
          for (let i = 0; i < res.Data.length; i++)
            result[i] = { ...res.Data[i], rank: (current - 1) * 20 + 1 + i };
          setGather({
            ...gather,
            data: result,
          });
          setLoading(false);
        } else if (pageSize === 50) {
          for (let i = 0; i < res.Data.length; i++)
            result[i] = { ...res.Data[i], rank: (current - 1) * 50 + 1 + i };
          setGather({
            ...gather,
            data: result,
          });
          setLoading(false);
        } else if (pageSize === 100) {
          for (let i = 0; i < res.Data.length; i++)
            result[i] = { ...res.Data[i], rank: (current - 1) * 100 + 1 + i };
          setGather({
            ...gather,
            data: result,
          });
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
  };
  const onTableChange = (pagination: TablePaginationConfig) => {
    setCountDown(60);
    setPageInfo({
      pageSize: pagination.pageSize || 100,
      current: pagination.current || 1,
    });
    if (type === "grade") {
      fetchNewGrade(pagination.pageSize || 100, pagination.current || 1);
    } else if (type === "gather") {
      fetchNewGather(pagination.pageSize || 100, pagination.current || 1);
    }
  };
  const handleCurrentPage = () => {
    return pageInfo.current;
  };
  const handleMatchGameID = async (gameType = "0") => {
    setGameName("----");
    const fetchIDs = await fetch(
      `${process.env.REACT_APP_API_URL}ApiGetJsonGameID.ashx?mID=${matchid}&gameType=${gameType}`,
      {
        method: "GET",
        headers: {
          "content-Type": "application/json; charset=utf-8",
        },
      }
    );
    const parsedData = await fetchIDs.json();
    const flatten = await parsedData.Data.map(
      (d: { MatchGameID: number }) => d.MatchGameID
    );
    const newestOne = await flatten.sort(
      (a: number, b: number) => b - a > 0
    )[0];
    dispatch({ gameid: newestOne });
    setGameTypeSwitch(gameType);
    fetchData(newestOne);
    fetchGrade(newestOne, 100, 1, "", "");
    history.push(`/racelive/${matchid}/${newestOne}/${gameType}`);
    fetchMatchList(gameType);
  };
  const fetchMatchList = (matchGameType = gameTypeSwitch) => {
    if (matchGameType !== null) {
      fetch(
        `${process.env.REACT_APP_API_URL}ApiGetJsonMatchGame.ashx?MatchId=${matchid}&MatchGameType=${matchGameType}&CurrentPage=1`
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.Data.length !== 0) {
            const sorted = res.Data.sort(
              (a: { MatchGameID: number }, b: { MatchGameID: number }) =>
                b.MatchGameID - a.MatchGameID
            );
            setMatchList(sorted);
            setScoreCalcType(sorted[0].ScoreCalcType);
          } else if (res.Data.length === 0) {
            alert("查无资料");
            setData([
              {
                ClockStop: "2000-01-01T06:00:00",
                ClockStart: "2000-01-01T06:00:00",
                BasicMetresPerMin: "",
                TotalBird: "",
                NowCount: "",
                StringE_HMS: "0°0′0″",
                StringN_HMS: "0°0′0″",
              },
            ]);
            if (type === "grade") {
              setGrade({
                data: [],
                totalPage: 0,
                count: "",
              });
            } else if (type === "gather") {
              // type is never set to gather, dead code?
              setGather({
                data: [],
                totalPage: 0,
                count: "",
              });
            }
            setLoading(false);
            setGameName("---");
            setMatchList(null);
          } else {
            console.log("error!");
          }
        });
    }
  };
  const refresh = () => {
    setCountDown(60);
    fetchData(state?.gameid || undefined);
    if (type === "grade") {
      setGrade(initialState);
      fetchGrade(state?.gameid || undefined);
    } else if (type === "gather") {
      setGather(initialState);
      fetchGather(state?.gameid || undefined);
    }
  };
  const handleSearch = () => {
    if (type === "grade") {
      setGrade(initialState);
      setPageInfo({ pageSize: 100, current: 1 });
      preventRefreshCount(searchGrade, 3);
    } else if (type === "gather") {
      setGather(initialState);
      setPageInfo({ pageSize: 100, current: 1 });
      preventRefreshCount(searchGather, 3);
    }
  };
  function useDebounce(fn: Function, delay: number) {
    const ref = useRef<{ fn: Function; timer: any }>({ fn, timer: null });
    useEffect(() => {
      ref.current.fn = fn;
    }, [fn]);
    function f(...args: any[]) {
      if (ref.current.timer) {
        clearTimeout(ref.current.timer);
      }
      ref.current.timer = setTimeout(function (this: any) {
        (ref.current.fn as Function).call(this, ...args);
      }, delay);
    }
    return f;
  }
  const dataToXlsx = async (tableData: Obj[]) => {
    if (tableData) {
      const sheet = XLSX.utils.json_to_sheet(tableData);
      const workbook = XLSX.utils.book_new();
      sheet["!cols"] = [
        { wch: 6 },
        { wch: 10 },
        { wch: 15 },
        { wch: 10 },
        { wch: 12 },
        { wch: 25 },
        { wch: 20 },
        { wch: 25 },
        { wch: 12 },
        { wch: 25 },
        { wch: 15 },
      ];
      XLSX.utils.book_append_sheet(workbook, sheet, "workbook");
      XLSX.writeFile(workbook, "资料表.xlsx");
    } else {
      return;
    }
  };
  const handleDownload = async () => {
    setSpinLoading(true);
    if (window.confirm(`确认下载？`)) {
      const fetchData = await fetch(
        `${
          process.env.REACT_APP_API_URL
        }ApiGetJsonGameDetailExportData.ashx?MatchGameID=${gameid}&MatchID=${matchid}&Gid=${localStorage.getItem(
          "gid"
        )}&SearchFeetNo=${findName.searchFeetNo}&SearchName=${
          findName.searchName
        }`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json; charset=utf-8",
            Authorization: localStorage.getItem("token") || "",
          },
        }
      );
      const parsedData = await fetchData.json();
      if (parsedData.InfoGet[0].Status === "Success") {
        const printData = await parsedData.Data.map(
          (d: IGameDetailExportData) =>
            scoreCalcType === 0
              ? {
                  暂排: d.Rank,
                  "分速（米/分）": Number(d.MetresPerMin).toFixed(4),
                  综合排名: d.TotalRank,
                  "综合分速（米/分）": d.TotalMetresPerMin,
                  参赛名编号: d.LoftID,
                  参赛名: d.LoftName,
                  环号: d.FeetNo,
                  寄养人: d.FeetName,
                  羽色: d.Feather,
                  归巢时间: d.StringDate,
                  "空距（米）": d.Distance,
                }
              : {
                  暂排: d.Rank,
                  "分速（米/分）": Number(d.MetresPerMin).toFixed(4),
                  平均排名: d.AvgRank,
                  "平均分速（米/分）": d.AvgMetresPerMin,
                  参赛名编号: d.LoftID,
                  参赛名: d.LoftName,
                  环号: d.FeetNo,
                  寄养人: d.FeetName,
                  羽色: d.Feather,
                  归巢时间: d.StringDate,
                  "空距（米）": d.Distance,
                }
        );
        dataToXlsx(printData);
        setSpinLoading(false);
      } else {
        alert("请联系管理员");
        setSpinLoading(false);
      }
    } else {
      setSpinLoading(false);
    }
  };
  const searchGrade = useDebounce(
    () => fetchGrade(state?.gameid || undefined),
    500
  );
  const searchGather = useDebounce(
    () => fetchGather(state?.gameid || undefined),
    500
  );

  useEffect(() => {
    setFindName({
      matchGameID: state?.gameid || "",
      searchName: "",
      searchFeetNo: "",
    });
  }, [state.gameid]);
  useEffect(() => {
    if (rank !== "") {
      if (type === "grade") {
        fetchGrade(state.gameid);
      } else {
        // type is never set to gather, dead code?
        fetchGather(state.gameid);
      }
    } else {
      setLoading(false);
    }
  }, [rank]);
  useEffect(() => {
    setType("grade");
  }, [gameTypeSwitch]);
  useEffect(() => {
    setCountDown(60);
  }, [data, type]);
  useEffect(() => {
    const referenceSpeed = setTimeout(() => {
      if (data !== null && data.length > 0) {
        setSpeed(refreshSpanSpeed(data[0] as IGameTop) || null);
        setFly(flyReference(data[0] as IGameTop) || null);
      }
    }, 1000);
    return () => {
      clearTimeout(referenceSpeed);
    };
  }, [data, fly, speed]);
  useEffect(() => {
    if (type !== "" && localStorage.getItem("onAuth") === "true") {
      handleAuth();
    }
  }, [grade, gather, type]);
  useEffect(() => {
    const count = setTimeout(() => {
      setCountDown(countDown - 1);
      if (countDown === 0) {
        fetchData(state?.gameid || undefined);
        if (type === "grade") {
          fetchGrade(state?.gameid || undefined);
        } else {
          fetchGather(state?.gameid || undefined);
        }
        setCountDown(60);
      }
    }, 1000);
    return () => {
      clearTimeout(count);
    };
  }, [countDown]);
  const newestGame = async () => {
    const fetchID = await fetch(
      `${process.env.REACT_APP_API_URL}ApiGetJsonNewGame.ashx?MatchID=${matchid}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=utf-8",
        },
      }
    );
    const parsedData = await fetchID.json();
    if (!parsedData?.Data || parsedData.Data.length === 0) {
      alert("无最新赛事");
      history.push("/");
      return;
    }
    const gameID = parsedData.Data[0].GameID;
    dispatch({ gameid: gameID });
    const gameType = parsedData.Data[0].Type;
    handleMatchGameID(gameType);
    setGameTypeSwitch(gameType);
    history.push(`/racelive/${matchid}/${gameID}/${gameType}`);
  };
  const tabsResetOnClick = () => {
    setCountDown(60);
    setFindName({
      ...findName,
      searchFeetNo: "",
      searchName: "",
    });
    if (type === "grade") {
      setGrade(initialState);
      preventRefreshCount(searchGrade, 3);
    } else if (type === "gather") {
      setGather(initialState);
      preventRefreshCount(searchGather, 3);
    }
  };
  useEffectOnce(() => {
    if (showNewest && /^([1-9][0-9]*|0)$/.test(matchid)) {
      /*
        is matchid valid integer string?
      */
      newestGame();
      return;
    } else if (
      ![matchid, gameid, gametype].every((v) => /^([1-9][0-9]*|0)$/.test(v))
    ) {
      /*
        are matchid, gameid and gametype are valid integer strings?
      */
      alert("网址格式错误");
      history.push("/");
      return;
    }
    const matchID = Number.parseInt(matchid);
    const gameID = Number.parseInt(gameid);
    const gameType = Number.parseInt(gametype);

    (async () => {
      const availableGames = await GETJsonGameID(matchID, gameType);
      if (availableGames.length === 0) {
        /*
          is availableGame defined and not empty?
       */
        alert("没有此赛事/训飞");
        history.push("/");
      } else if (!availableGames.some((v: Obj) => v.MatchGameID === gameID)) {
        /*
          does gameID exist in availableGames?
        */
        alert("没有此赛事/训飞");
        history.push("/");
      } else {
        fetchData(gameid);
        fetchGrade(gameid);
        setGameTypeSwitch(gameType);
        dispatch({ gameid });
        setFindName({
          matchGameID: gameid,
          searchFeetNo: "",
          searchName: "",
        });
        setGameTypeSwitch(gameType);
        fetchMatchList(gameType);
      }
    })();
  }, []);
  useEffect(() => {
    if (state.gid) {
      GETJsonRaceLiveSetting(state.gid, "racelive").then((json) => {
        setSettings(json);
      });
    }
  }, [state.gid]);

  return (
    <>
      {ctx}
      <DefaultLayout>
        <Spin spinning={spinLoading} tip={"请等候3秒"}>
          <RaceOutter>
            <Container>
              {data &&
                data.map((d, i) => (
                  <div key={i}>
                    <Row gutter={16}>
                      <Col span={24}>
                        <RaceLiveData
                          isMatch={isMatch}
                          grade={grade}
                          data={d}
                          fly={fly}
                          speed={speed}
                          gameName={gameName}
                          typeList={typeList}
                          matchDropdownList={matchDropdownList}
                          typeListOnClick={typeListOnClick}
                          matchListDropdownOnClick={matchListDropdownOnClick}
                          backPercent={backPercent}
                        />
                      </Col>
                    </Row>
                    <Row align="middle">
                      <Col span={24} style={{ overflowX: "auto" }}>
                        {(() => {
                          if (isMatch) {
                            return <TableSkeleon data={d as IGameTop} />;
                          } else if (
                            d.StringE_HMS !== "0°0′0″" &&
                            d.StringN_HMS !== "0°0′0″"
                          ) {
                            return <TableSkeleon data={d as IGameTop} />;
                          } else {
                            return null;
                          }
                        })()}
                      </Col>
                    </Row>
                  </div>
                ))}
            </Container>
          </RaceOutter>
          <GradeDetail>
            <Container>
              <RaceliveTabs
                countDown={countDown}
                findName={findName}
                data={data || []}
                type={type}
                sortText={sortText}
                resetOnClick={tabsResetOnClick}
                setFindName={setFindName}
                handleList={handleList}
                handleEnter={handleEnter}
                handleSearch={handleSearch}
                handleDownload={handleDownload}
                handleMenuClick={handleMenuClick}
                preventRefreshCount={preventRefreshCount}
                refresh={refresh}
              />
              <RaceliveTable
                isMatch={isMatch}
                type={type}
                grade={grade}
                gather={gather}
                loading={loading}
                data={(data as IGameTop[]) || []}
                findName={findName}
                pageInfo={pageInfo}
                settings={settingsObj}
                setFindName={setFindName}
                setPageInfo={setPageInfo}
                setLoading={setLoading}
                setCountDown={setCountDown}
                handleCurrentPage={handleCurrentPage}
                onTableChange={onTableChange}
                searchGather={searchGather}
                searchGrade={searchGrade}
              />
            </Container>
          </GradeDetail>
        </Spin>
      </DefaultLayout>
    </>
  );
};

export default Racelive;
